'use client';
import React from 'react';
import { motion } from 'framer-motion';
import { ReactSVG } from 'react-svg';
import { hideDecorativeSvg } from '@/lib/a11y';
import s from './AvisoPrivacidad.module.css';
import { SvgLoader } from '@/lib/imageLoader';
import { AvisoProps } from '@/types/model';

const AvisoPrivacidad = ({ title, description, logo, items }: AvisoProps) => {
  return (
    <motion.div className={s.container} initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}>
      <div className={s.container__wrapper}>
        <ReactSVG
          className={s.container__logo}
          src={SvgLoader({ src: logo?.url })}
          wrapper="span"
          beforeInjection={(svg: SVGSVGElement) => {
            hideDecorativeSvg(svg);
            svg.classList.add('svg__icon__left');
          }}
        />
        <p>{description}</p>
        <h1>{title}</h1>
        {items.map((item) => {
          return (
            <>
              <p>{item.label}</p>
              <p>{item.data}</p>
            </>
          );
        })}
      </div>
      <div className={s.container__forma}></div>
    </motion.div>
  );
};

export default AvisoPrivacidad;
